import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { OnboardingFlow } from './pages/OnboardingFlow';
import { Boardroom } from './pages/Boardroom';
import { ChatInterface } from './pages/ChatInterface';
import { EmailConfirmPage } from './pages/EmailConfirmPage';

function App() {
  // Add error boundary
  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    const handleError = (error: any) => {
      console.error('App error:', error);
      setHasError(true);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleError);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleError);
    };
  }, []);

  if (hasError) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-900 via-black to-orange-900 flex items-center justify-center p-4">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-white mb-4">Something went wrong</h1>
          <p className="text-white/70 mb-6">Please refresh the page or check the console for details.</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-6 py-3 rounded-xl bg-gradient-to-r from-orange-500 to-purple-500 text-white hover:from-orange-400 hover:to-purple-400 transition-all duration-300"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-purple-900 via-black to-orange-900">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth/confirm" element={<EmailConfirmPage />} />
          <Route path="/onboarding" element={<OnboardingFlow />} />
          <Route path="/boardroom" element={<Boardroom />} />
          <Route path="/boardroom/:chatId" element={<ChatInterface />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;